import { Card } from "@mui/material";
import CommonLayout from "components/CommonLayout";
import MDBox from "components/MDBox";
import ShowToast from "components/MDToast";
import MDTypography from "components/MDTypography";
import ExchangeDetails from "components/ReturnExchangeDetails";
import { STORAGE_KEYS } from "helpers";
import { getFromStorage } from "helpers";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLazyGetOrderByIdQuery } from "services/order";
import { useLazyGetReturnExchangeByIdQuery } from "services/returnExchange";

const ReturnExchangeDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const currency = getFromStorage(STORAGE_KEYS.currency);
  const { state } = useLocation();
  const [orderById] = useLazyGetReturnExchangeByIdQuery();
  const [orderData, setOrderData] = useState(null);

  const getOrderDetails = async () => {
    try {
      const res = await orderById({
        id,
        type: state,
      }).unwrap();
      if (res?.status === 200) {
        setOrderData(res?.data);
      }
    } catch (error) {
      console.log(error, "error");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <CommonLayout>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Return & Exchange Details
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/return-exchange")}
          >
            Back
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <ExchangeDetails orderData={orderData} type={state} />
        </MDBox>
      </Card>
    </CommonLayout>
  );
};

export default ReturnExchangeDetails;
